import * as modalTypes from './modalTypes'
import { FriendModal, WinkModal, MessageModal, ProfileUpdateModal } from './Basic'
import UploadImageModal from './UploadImage'
import GalleryModal from './Gallery'
import ConfirmEmail from './ConfirmEmail'
import { FlagSetter, ThemeEditor, ThemePreview } from './FlagSetter'

export const modalsMap = {
  [modalTypes.FRIEND_MODAL]: FriendModal,
  [modalTypes.WINK_MODAL]: WinkModal,
  [modalTypes.GALLERY_MODAL]: GalleryModal,
  [modalTypes.PROFILE_UPDATE_MODAL]: ProfileUpdateModal,
  [modalTypes.UPLOAD_PHOTO_MODAL]: UploadImageModal,
  [modalTypes.FLAG_SETTER_MODAL]: FlagSetter,
  [modalTypes.MESSAGE_MODAL]: MessageModal,
  default: MessageModal,
}
export {
  FriendModal,
  WinkModal,
  MessageModal,
  ProfileUpdateModal,
  UploadImageModal,
  GalleryModal,
  ConfirmEmail,
  FlagSetter,
  ThemeEditor,
  ThemePreview,
}
